module.exports = __webpack_public_path__ + "img/2.7da48e64.jpg";